<template>
  <div class='home'>
    <PromoList
      v-show='listView'
      @newPromo='onClickNewFromList'
      @editPromo='onClickEditFromList'
      :scroll="corY" ref='refreshList'
    />
    <PromoForm
      v-show='formView'
      :promo='promo'
      @backClicked='onBackChild'
    />
  </div>
</template>

<script>
// @ is an alias to /src
import PromoList from '@/components/promo/PromoList.vue'
import PromoForm from '@/components/promo/PromoForm.vue'

export default {
  name: 'Promo',
  components: {
    PromoList,
    PromoForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      promo: {
        id: null,
        name: null,
        dicount: 0,
        valid_date: null,
        percentage: true
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.promo = value
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      const date = new Date().toISOString()
      this.listView = false
      this.formView = true
      this.promo = {
        id: null,
        name: null,
        dicount: 0,
        valid_date: date,
        percentage: true
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.promo = {
        id: null,
        name: null,
        dicount: 0,
        valid_date: null,
        percentage: true
      }
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  },
  mounted () {
    // this.$store.dispatch('')
  }
}
</script>
